import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ dealershipName }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md transition-all duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div
            className="cursor-pointer transition-all duration-300 hover:scale-105"
            onClick={() => scrollToSection('hero')}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_wilke-auto-portal/artifacts/sdbsg346_fixed_autohaus-wilke.ai_black.png"
              alt={dealershipName}
              className="h-16 w-auto object-contain transition-all duration-300"
              style={{ 
                maxWidth: '280px'
              }}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a
              href="/index.html"
              className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors duration-300"
            >
              Startseite
            </a>
            <a
              href="/verkauf.html"
              className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors duration-300"
            >
              Verkauf
            </a>
            <a
              href="/werkstatt.html"
              className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors duration-300"
            >
              Werkstatt
            </a>
            <a
              href="/fahrzeugbestand.html"
              className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors duration-300"
            >
              Fahrzeugbestand
            </a>
            <button
              onClick={() => scrollToSection('kontakt')}
              className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors duration-300"
            >
              Kontakt
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md shadow-lg">
          <nav className="flex flex-col space-y-4 px-4 py-6">
            <a
              href="/index.html"
              className="text-left text-gray-700 hover:text-gray-900 font-medium transition-colors duration-300"
            >
              Startseite
            </a>
            <a
              href="/verkauf.html"
              className="text-left text-gray-700 hover:text-gray-900 font-medium transition-colors duration-300"
            >
              Verkauf
            </a>
            <a
              href="/werkstatt.html"
              className="text-left text-gray-700 hover:text-gray-900 font-medium transition-colors duration-300"
            >
              Werkstatt
            </a>
            <a
              href="/fahrzeugbestand.html"
              className="text-left text-gray-700 hover:text-gray-900 font-medium transition-colors duration-300"
            >
              Fahrzeugbestand
            </a>
            <button
              onClick={() => scrollToSection('kontakt')}
              className="text-left text-gray-700 hover:text-gray-900 font-medium transition-colors duration-300"
            >
              Kontakt
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
